import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'fes-serviceupdates',
  templateUrl: './serviceupdates.component.html',
  styleUrls: ['./serviceupdates.component.scss']
})
export class ServiceupdatesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
